import { t } from '@lingui/macro';
import { CaddyTabType, CaddyTab } from './types';

export const caddyTabs: CaddyTab[] = [
  { label: t`Add New Caddy`, value: CaddyTabType.ADD },
  { label: t`Issued Caddies`, value: CaddyTabType.ISSUED },
];
